import authReducer from "./auth.slice";
import departmentReducer from "./department.slice";
import settingsReducer from "./settings.slice";
import staffReducer from "./staff.slice";
import projectReducer from './project.slice';
import billingCycleReducer  from "./billing-cycle.slice";
import vendorReducer  from "./vendor.slice";
import accountsReducer from "./accounts.slice";
import activityLogReducer from "./activity-log.slice";
import subDepartmentReducer from "./sub-department.slice";
import masterReducer from "./master.slice";
import milestoneReducer from "./milestone.slice";
import candidateScreeningReducer from "./candidate-screening.slice";
import userManagementReducer from "./user.slice";
import roleReducer from "./role.slice";
import documentTypeReducer from "./document-type.slice";
import documentSubTypeReducer from "./document-sub-type.slice";

const allReducers = {
  auth: authReducer,
  settings: settingsReducer,
  staff: staffReducer,
  department: departmentReducer,
  subDepartment: subDepartmentReducer,
  project: projectReducer,
  billingCycle: billingCycleReducer,
  vendor: vendorReducer,
  account: accountsReducer,
  activityLog: activityLogReducer,
  master: masterReducer,
  milestone: milestoneReducer,
  candidateScreening: candidateScreeningReducer,
  userManagement: userManagementReducer,
  role: roleReducer,
  documentType: documentTypeReducer,
  documentSubType: documentSubTypeReducer,
};

export default allReducers;
